import React from 'react';
import { Box, Typography, LinearProgress, Paper } from '@mui/material';

const ProgressBarWidget = ({
  title = "Progress",
  value = 0,
  maxValue = 100,
  color = "primary",
  showPercentage = true,
  showValue = false,
  height = 8,
  variant = "widget", // widget, simple, card
  sx = {}
}) => {
  const percentage = Math.round((value / maxValue) * 100);

  if (variant === "simple") {
    return (
      <Box sx={{ width: '100%', ...sx }}>
        <LinearProgress
          variant="determinate"
          value={percentage}
          color={color}
          sx={{ height, borderRadius: height / 2 }}
        />
      </Box>
    );
  }

  if (variant === "card") {
    return (
      <Paper elevation={2} sx={{ p: 3, ...sx }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
          <Typography variant="h6" fontWeight={500}>
            {title}
          </Typography>
          <Typography variant="h6" color={`${color}.main`} fontWeight={600}>
            {showPercentage ? `${percentage}%` : `${value}/${maxValue}`}
          </Typography>
        </Box>
        <LinearProgress
          variant="determinate"
          value={percentage}
          color={color}
          sx={{ 
            height: height + 2, 
            borderRadius: (height + 2) / 2,
            backgroundColor: 'grey.200'
          }}
        />
      </Paper>
    );
  }

  // Default widget variant
  return (
    <Box sx={{ width: '100%', ...sx }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography variant="body2" color="text.secondary">
          {title}
        </Typography>
        {(showPercentage || showValue) && (
          <Typography variant="body2" fontWeight={500} color={`${color}.main`}>
            {showPercentage ? `${percentage}%` : `${value}/${maxValue}`}
          </Typography>
        )}
      </Box>
      <LinearProgress
        variant="determinate"
        value={percentage}
        color={color}
        sx={{ 
          height, 
          borderRadius: height / 2,
          backgroundColor: 'grey.200',
          '& .MuiLinearProgress-bar': {
            borderRadius: height / 2,
          }
        }}
      />
    </Box>
  );
};

export default ProgressBarWidget;
